import type { Book } from '@booknest/shared';

import { apiClient } from '@/shared/api/client.js';

export interface CollectionView {
  id: string;
  userId: string;
  name: string;
  description: string | null;
  emoji: string;
  color: string | null;
  bookIds: string[];
  createdAt: string;
  updatedAt: string;
}

export interface CollectionDetailsView extends CollectionView {
  books: Book[];
}

export interface CreateCollectionInput {
  name: string;
  description?: string;
  emoji: string;
  color?: string;
  bookIds?: string[];
}

export interface UpdateCollectionInput {
  name?: string;
  description?: string | null;
  emoji?: string;
  color?: string | null;
  bookIds?: string[];
}

export const collectionsApi = {
  async list(): Promise<{ items: CollectionView[] }> {
    const { data } = await apiClient.get<{ items: CollectionView[] }>(
      '/collections',
    );
    return data;
  },

  async create(input: CreateCollectionInput): Promise<{ collection: CollectionView }> {
    const { data } = await apiClient.post<{ collection: CollectionView }>(
      '/collections',
      input,
    );
    return data;
  },

  async details(id: string): Promise<{ collection: CollectionDetailsView }> {
    const { data } = await apiClient.get<{ collection: CollectionDetailsView }>(
      `/collections/${id}`,
    );
    return data;
  },

  async update(
    id: string,
    patch: UpdateCollectionInput,
  ): Promise<{ collection: CollectionView }> {
    const { data } = await apiClient.patch<{ collection: CollectionView }>(
      `/collections/${id}`,
      patch,
    );
    return data;
  },

  async remove(id: string): Promise<void> {
    await apiClient.delete(`/collections/${id}`);
  },
};
